import { Tabs, Tab } from '@mui/material';
import { styled } from '@mui/system';
import { TabProps } from 'src/models/FieldProps.interface';
import { SyntheticEvent } from 'react';

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderRight: `1px solid ${theme.palette.divider}`,
  minWidth: '200px',
  marginRight: '32px',
  '& .MuiTabs-indicator': {
    display: 'none',
  },
}));

const StyledTab = styled(Tab)<TabProps>(({ selected, sx }) => ({
  fontSize: '14px',
  fontWeight: selected ? '500' : '400',
  fontFamily: 'Outfit',
  color: selected ? 'var(--primary-blue)' : 'var(--primary-navy)',
  textTransform: 'none',
  alignItems: 'flex-start',
  width: '100%',
  backgroundColor: selected ? 'var(--inactive-btn)' : 'transparent',
  borderRadius: '8px',
  '&:hover': {
    color: 'var(--primary-blue)',
  },
  ...sx,
}));

interface CustomTabsProps {
  selectedTab: number;
  handleTabChange: (event: SyntheticEvent, newValue: number) => void;
  isOwner: boolean;
}

export default function CustomTabs({
  selectedTab,
  handleTabChange,
  isOwner,
}: CustomTabsProps) {
  return (
    <StyledTabs
      orientation="vertical"
      value={selectedTab}
      onChange={handleTabChange}
    >
      <StyledTab label="Profile" selected={selectedTab === 0} />
      {isOwner && <StyledTab label="Company" selected={selectedTab === 1} />}
      {isOwner && <StyledTab label="Billing" selected={selectedTab === 2} />}
    </StyledTabs>
  );
}
